__turbopack_context__.v({
  "center": "page-module-scss-module__gSgIWG__center",
  "root": "page-module-scss-module__gSgIWG__root",
});
